
export default {
    maxHeight: '100%',
    maxWidth: '100%',

    // font
    fontMinimum: '6pt',
    fontSmall: '10pt',
    fontMidium: '12pt',
    fontMediumLarge: '20pt',
    fontLarge: '30pt',
    fontMax: '40pt',
    fontImage: '50pt',

    fontResultBigComment:'12pt',

    clockSize:'150px',
}

